// Fetch orders from the API
import instance from "../../utils/axios";

export const getOrderHistory = async () => {
  try {
    return await instance.get(`/order-history`);
  } catch (error) {
    console.error("Error fetching orders:", error.message);
    throw error; // Rethrow for further handling
  }
};
